import React from 'react';

// Material UI
import { makeStyles, Typography } from '@material-ui/core';

// Components and Others
import PropTypes from 'prop-types';
import NumberUtils from 'lib/NumberUtils';
import { round } from 'lodash';

const useStyles = makeStyles((theme) => ({
    summaryText: {
        display: 'grid',
        width: 200,
        paddingLeft: 5,
        gridTemplateColumns: 'repeat(2, 1fr)',
        overflow: 'auto',
    },
    summaryTextInLine: {
        display: 'flex',
        overflow: 'auto',
        padding: 5,
    },
    contentSpace: {
        marginRight: theme.spacing(2),
        textAlign: 'right',
    },
    difference: {
        color: theme.palette.error.main,
    },
}));

const PurchaseOrderDetailSummary = ({
    subTotal, displayInline, fees,
}) => {
    const classes = useStyles();

    return (
        <Typography
            variant="h6"
            className={displayInline ? classes.summaryTextInLine : classes.summaryText}
        >
            <span>Subtotal:&nbsp;</span>
            <span className={classes.contentSpace}>{NumberUtils.applyCurrencyFormat(subTotal)}</span>
            <span>Fees:&nbsp;</span>
            <span className={classes.contentSpace}>{NumberUtils.applyCurrencyFormat(fees)}</span>
            <span>Total:&nbsp;</span>
            <span className={classes.contentSpace}>{NumberUtils.applyCurrencyFormat(round((subTotal - fees), 2))}</span>
        </Typography>
    );
};

PurchaseOrderDetailSummary.propTypes = {
    subTotal: PropTypes.number,
    displayInline: PropTypes.bool,
    fees: PropTypes.number,
};

PurchaseOrderDetailSummary.defaultProps = {
    subTotal: 0,
    displayInline: true,
    fees: 0,
};

export default PurchaseOrderDetailSummary;
